module.exports = __webpack_public_path__ + "static/media/bottle_basket_01.e6a6806a.jpg";